// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__auWiD","wrap":"Preloader_wrap__HKMzL","loader":"Preloader_loader__quJfy","blast":"Preloader_blast__gf1ME","bounce":"Preloader_bounce__THfvk"};